import { createBigDecimal, times } from '@0xtorch/big-decimal'
import type { Transfer } from '@0xtorch/core'

/**
 * 円との売買へ変換可能な唯一の資産移動を返す。
 * @param params 資産移動の一覧。
 * @returns 増減が1件だけの場合はその資産移動、それ以外は undefined。
 */
export const findJpyTradeConvertibleTransfer = <
  TTransfer extends { readonly direction: Transfer['direction'] },
>({
  transfers,
}: { readonly transfers: readonly TTransfer[] }): TTransfer | undefined => {
  if (transfers.length !== 1) return undefined
  const [transfer] = transfers
  return transfer.direction === 'in' || transfer.direction === 'out'
    ? transfer
    : undefined
}

/**
 * 円側の数量を元の数量と価格から計算する。
 * @param params 元の数量と任意の価格。
 * @returns 価格設定済みなら数量と価格の積、未設定なら1。
 */
export const createJpyTradeAmount = ({
  amount,
  price,
}: {
  readonly amount: Transfer['amount']
  readonly price?: Transfer['price']
}): Transfer['amount'] =>
  price === undefined ? createBigDecimal(1n) : times(amount, price)
